<template>
  <div :class="$style.logoContainer">
    <img src="@/assets/img/Logo2.png" alt="EZTaX Solver&reg;">
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" module>
.logoContainer {
  max-width: 180px;
  margin: 0 auto;
  padding: 22px 0 0;
}
</style>
